module.exports = __webpack_public_path__ + "static/media/20ECE21.d5a70167.jpg";